import { Component, Input, OnInit } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { MobileResultDetailsModalComponent } from '../mobile-result-details-modal/mobile-result-details-modal.component';
import { MobileComponentInputDialogComponent } from './mobile-component-input-dialog/mobile-component-input-dialog.component';

@Component({
  selector: 'app-mobile-result',
  templateUrl: './mobile-result.component.html',
  styleUrls: ['./mobile-result.component.less']
})
export class MobileResultComponent implements OnInit {
  @Input() mobileInstructions: any;
  @Input() mostRecentExecuted: any;
  @Input() parentIndex: any;
  @Input() showGraphSection = false;
  showGraph = false;

  ngOnInit(): void {
    console.log(this.mostRecentExecuted?.execution?.executionStatus);
  }

  constructor(private modalService: NgbModal) { }

  openInfoDialog(element: any) {
    const modalRef = this.modalService.open(
      MobileResultDetailsModalComponent,
      {
        ariaLabelledBy: "modal-basic-title",
        backdrop: true,
        centered: true,
        size: "xl",
      }
    );

    console.log(element);
    modalRef.componentInstance.mostRecentExecuted = this.mostRecentExecuted;
    modalRef.componentInstance.mobileInstruction = element;
    modalRef.componentInstance.title = "CAPABILITIES";
  }

  getDateTime(data) {
    var date = new Date(data);
    return date.toLocaleDateString("en-US") + " " + date.toLocaleTimeString("en-US");
  }

  openComponentInputDialog(mobileInstruction : any) {
    const modalRef = this.modalService.open(
      MobileComponentInputDialogComponent,
      {
        ariaLabelledBy: "modal-basic-title",
        backdrop: true,
        centered: true,
        size: "xl",
      }
    );

    modalRef.componentInstance.mobileInstruction = mobileInstruction;
  }
}